import company from './company'

const CompanyServer = {
    company,
};

export default CompanyServer;
